import { useEffect, useState } from 'react';

import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

/**
 *
 * @param featureGateName
 * @returns true or false
 *
 * Use this hook when there is a shared feature gate between Confluence and canvas.
 * The feature gates are configured in confluence: https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/confluence/next/packages/confluence-databases/src/database-feature-gates.json
 */
export const useIsFeatureEnabled = (featureGateName: string) => {
  const [isFeatureEnabled, setIsFeatureEnabled] = useState(false);

  useEffect(() => {
    const getFeatureGateValue = async () => {
      try {
        const contentApi = await waitForContentAPI();
        const isEnabled =
          contentApi.confluenceAPI?.shell?.isFeatureActive?.(featureGateName) || false;

        setIsFeatureEnabled(isEnabled);
      } catch (e) {
        console.error('Failed to grab feature gate value', e);
      }
    };

    getFeatureGateValue();
  }, [featureGateName]);

  return isFeatureEnabled;
};
